import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { useMergeStyles } from "@insite/content-library/additionalStyles";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Img from "@insite/mobius/Img";
import { LazyImage, Link } from "@insite/mobius/index";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { BannerCarouselList } from "@NA/Services/GetBannerCarousel";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import ADIColors from "@NA/Utils/ADIColors";
import React from "react";
import { useSelector } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    slide: BannerCarouselList;
    extendedStyles?: ADIPdpBannerSlideStyles;
}

export interface ADIPdpBannerSlideStyles {
    slideContentWrapper?: InjectableCss;
    slideOverlayWrapper?: InjectableCss;
}

export const adiPdpBannerSlideStyles: ADIPdpBannerSlideStyles = {
    slideContentWrapper: {
        css: css`
            display: flex;
            flex: 0 0 100%;
            position: relative;
            color: ${ADIColors.white};
            background-repeat: no-repeat;
            height: auto;
        `,
    },
    slideOverlayWrapper: {
        css: css`
            width: 100%;
            display: flex;
            justify-content: space-between;
            max-width: 100%;
            margin: 20px 0 0 0;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 0;
                    `,
                    null,
                    null,
                    null,
                    null,
                ])}
        `,
    },
};

const ADIPdpBannerSlide = ({ slide, extendedStyles }: OwnProps) => {
    const styles = useMergeStyles("slideshow", adiPdpBannerSlideStyles, extendedStyles);
    const isPendingVerification = useSelector(
        (state: CustomApplicationState) => state.ADIGlobalData.PricingStatusStore.isPendingVerification,
    );

    if (isPendingVerification) {
        return null;
    }

    return (
        <StyledWrapper {...styles.slideContentWrapper} data-selector="pdpBanner">
            <StyledWrapper {...styles.slideOverlayWrapper} data-selector="pdpSlideBanner">
                <Link href={slide.bannerLinkUrl} {...styles.plpBannerLink} target="_blank">
                    {slide.backgroundImage ? (
                        <Img src={slide.backgroundImage} altText={slide.imageAlternativeText} />
                    ) : (
                        ""
                    )}
                </Link>
            </StyledWrapper>
        </StyledWrapper>
    );
};

export default ADIPdpBannerSlide;
